"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgThumbsDown = function SvgThumbsDown(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M16.351 28a3 3 0 01-3-3.452l1.38-8.998A2.997 2.997 0 0117.72 13H29a1 1 0 011 1v11a1 1 0 01-.086.406l-4 9A1 1 0 0125 35a4 4 0 01-4-4v-3h-4.649zM28 15H17.709a1 1 0 00-1 .852l-1.38 8.998A1 1 0 0016.34 26H22a1 1 0 011 1v4a2 2 0 001.392 1.906L28 24.788V15zm2 9h1.688A1.31 1.31 0 0033 22.923v-6.846A1.315 1.315 0 0031.67 15H30v9zm-1-11h2.652a3.31 3.31 0 013.339 2.866L35 16v7l-.009.134A3.305 3.305 0 0131.67 26H29a1 1 0 01-1-1V14a1 1 0 011-1z",
    id: "thumbs-down_svg__a"
  }));
};

var _default = SvgThumbsDown;
exports["default"] = _default;